module.exports = __webpack_public_path__ + "static/img/fingerpost_coupon_1.e0e3437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_coupon_1.jpg
// module id = 8KXh
// module chunks = 0